import { AuthToken, DecodedAuthToken } from '../types/AuthTypes';

export function setToken(token: string): void {
    localStorage.setItem('atlas_authToken', token);
}

export function getToken(): AuthToken | null {
    const token = localStorage.getItem('atlas_authToken');

    if (!token) {
        return null
    }

    return {
        access_token: token,
        token_type: 'bearer'
    }
}

export function removeToken(): void {
    localStorage.removeItem('atlas_authToken')
}

/**
 * Resolve admin vs user from JWT claims (see FeaturePlans/frontend-integration-guide.md).
 * Prefer `is_admin`, then explicit `role`.
 */
export function resolveRole(jwtRole: 'user' | 'admin' | undefined): 'user' | 'admin' {
    return resolveRoleFromDecoded({ role: jwtRole, is_admin: undefined });
}

/** Full resolution using `is_admin` and `role` from the decoded access token. */
export function resolveRoleFromDecoded(
    decoded: Pick<DecodedAuthToken, 'role' | 'is_admin'>
): 'user' | 'admin' {
    if (decoded.is_admin === true) return 'admin';
    if (decoded.role === 'admin' || decoded.role === 'user') return decoded.role;
    return 'user';
}
